import { render, staticRenderFns } from "./SelectPaymentTerm.vue?vue&type=template&id=baf22404&"
import script from "./SelectPaymentTerm.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports